import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function SingleAccordion({component, title}) {
  return (
      <Accordion >
        <AccordionSummary
         sx={{backgroundColor: 'white', borderRadius: '5px', minHeight: 30, maxHeight: 30 }}
          expandIcon={<ExpandMoreIcon/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
           {component}
          </Typography>
        </AccordionDetails>
      </Accordion>   
  );
}